// 登录
import service from '@/utils/request'

// 详情
export function systemView (data) {
  return service({
    url: '/service/admin/system_view',
    method: 'post',
    params: data
  })
}
export function systemSmsedit (data) {
  return service({
    url: '/service/admin/system_smsedit',
    method: 'post',
    params: data
  })
}
export function systemPayedit (data) {
  return service({
    url: '/service/admin/system_payedit',
    method: 'post',
    params: data
  })
}
export function toppayList (data) {
  return service({
    url: '/service/admin/toppay_list',
    method: 'post',
    params: data
  })
}
export function toppayedit (data) {
  return service({
    url: '/service/admin/toppay_edit',
    method: 'post',
    params: data
  })
}
